import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  FaUsers, FaCalendar, FaMoneyBill, FaBook, FaCar,
  FaChartLine, FaBell, FaFileAlt, FaCog, FaTools, FaUserCircle, FaUserTie, FaChartPie
} from 'react-icons/fa';
import { useAuth } from '../auth/AuthContext';

const dockItems = [
  { icon: <FaChartLine />, label: 'Dashboard', path: '/' },
  { icon: <FaUsers />, label: 'Users', path: '/users' },
  { icon: <FaFileAlt />, label: 'Schools', path: '/school-owners' },
  { icon: <FaUserTie />, label: 'Instructors', path: '/instructors' },
  { icon: <FaCalendar />, label: 'Bookings', path: '/bookings' },
  { icon: <FaMoneyBill />, label: 'Payments', path: '/payments' },
  { icon: <FaBook />, label: 'Courses', path: '/courses' },
  { icon: <FaCar />, label: 'Vehicles', path: '/vehicles' },
  { icon: <FaChartPie  />, label: 'Analytics', path: '/review-analytics' },
  { icon: <FaBell />, label: 'Notify', path: '/notifications' },
  { icon: <FaCog />, label: 'Settings', path: '/settings' },
  { icon: <FaTools />, label: 'Fix', path: '/troubleshoot' },
];

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#f9fafa] dark:bg-neutral-900 font-poppins text-gray-800 dark:text-gray-100 relative">
      {/* Command Center Header */}
      <header className="bg-white dark:bg-neutral-900 shadow-sm px-8 py-4 flex items-center justify-between">
        {/* Left: Brand */}
        <div className="flex items-center gap-3">
          <img src="/favicon.png.png" className="h-8" />
          <span className="text-xl font-bold text-driveeasy-blue2 tracking-wide font-poppins">DriveEasy Admin</span>
        </div>

        {/* Right: Profile + Quick Settings */}
        <div className="flex items-center gap-6">
          <input
            type="text"
            placeholder="Search..."
            className="bg-gray-100 dark:bg-neutral-800 dark:text-gray-100 px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-driveeasy-blue"
          />
          <FaBell className="text-xl text-driveeasy-blue hover:text-driveeasy-yellow cursor-pointer" />
          <div className="flex items-center gap-2 cursor-pointer">
            <FaUserCircle className="text-2xl text-gray-600 dark:text-gray-300" />
            <span className="font-medium text-sm text-gray-800 dark:text-gray-100 font-poppins">
             {user?.name || 'Admin'}
           </span>
           <button
             onClick={() => { logout(); navigate('/login', { replace: true }); }}
             className="ml-3 px-3 py-1.5 text-sm rounded border border-gray-200 dark:border-neutral-700 hover:bg-gray-100 dark:hover:bg-neutral-800"
           >
             Logout
           </button>
          </div>
        </div>
      </header>

      {/* Floating Dock */}
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-white/70 dark:bg-neutral-800/70 backdrop-blur-md shadow-lg rounded-full px-6 py-2 flex items-center space-x-6 z-50 border border-gray-200 dark:border-neutral-700">
        {dockItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return(
              <button
                key={index}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center group hover:scale-110 transition-all duration-300"
              >
              <div className={`text-xl ${isActive ? 'text-driveeasy-yellow' : 'text-driveeasy-blue dark:text-driveeasy-blue2'} group-hover:text-driveeasy-yellow`}>
                {item.icon}
              </div>
              <span className={`text-[10px] ${isActive ? 'text-black font-medium dark:text-gray-300 font-medium' : 'text-gray-500 dark:text-gray-500'} group-hover:text-black dark:group-hover:text-white`}>
                {item.label}
              </span>
            </button>
            );
          })}
      </div>

      {/* Main Page Content */}
      <main className="pt-4 pb-[96px] px-6">
        <Outlet />
      </main>

      {/* Optional: Command Palette (future) */}
      {/* Optional: Live Feed ticker */}
    </div>
  );
};

export default MainLayout;
